export const BillingModelFilters = () => {
  return [{
    label: 'User-based billing',
    description: 'Billed for selected number of users/agents of Marketplace app',
    id: 'user-access',
    value: 'user-access'
  }, {
    label: 'Linked billing',
    description: 'Billed for all users linked to Atlassian app',
    id: 'linked',
    value: 'linked'
  }];
};